import React, { useState, useEffect, useCallback } from 'react';
import PendientesDelDia from './PendientesDelDia';
import AccionesRapidas from './AccionesRapidas';
import './PanelInicio.css';

const hoyISO = () => new Date().toISOString().slice(0, 10);

// Panel de inicio: se muestra al loguearse, antes de entrar al calendario o
// a la ficha de un paciente. Igual para todos los perfiles (sin branching
// por profesión).
function PanelInicio({ pacientes, onVerFicha, onVerCalendario, onAgregarPaciente, onToggleSidebar, turnosRefreshSignal, onPacienteActualizado }) {
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const [fecha, setFecha] = useState(hoyISO());
  const [refreshSignal, setRefreshSignal] = useState(0);

  // Recalcula "hoy" si la pestaña queda abierta cruzando la medianoche.
  // Chequeo al recuperar foco/visibilidad en vez de un intervalo: evita
  // fetches innecesarios mientras la pestaña está en primer plano sin cambios.
  const revisarFecha = useCallback(() => {
    const actual = hoyISO();
    setFecha((prev) => (prev === actual ? prev : actual));
  }, []);

  useEffect(() => {
    window.addEventListener('focus', revisarFecha);
    document.addEventListener('visibilitychange', revisarFecha);
    return () => {
      window.removeEventListener('focus', revisarFecha);
      document.removeEventListener('visibilitychange', revisarFecha);
    };
  }, [revisarFecha]);

  return (
    <div className="panel-inicio inicio-wrapper">
      <div className="inicio-bienvenida">
        <h2>Bienvenido, {user?.first_name || user?.username}!</h2>
        <p>Este es tu panel de inicio: revisá los pendientes de hoy o usá los accesos rápidos.</p>
      </div>

      <div className="panel-inicio-grid">
        {/* Suma de dos contadores independientes (turno creado localmente vía
            AccionesRapidas, y turno creado/cancelado desde la bandeja de
            Google Calendar en App.js) -- a PendientesDelDia solo le importa
            que el valor cambie para disparar su refetch, no de cuál de los
            dos vino el cambio. */}
        <PendientesDelDia
          fecha={fecha}
          onVerFicha={onVerFicha}
          refreshSignal={refreshSignal + (turnosRefreshSignal || 0)}
          pacientes={pacientes}
          onPacienteActualizado={onPacienteActualizado}
        />
        <AccionesRapidas
          pacientes={pacientes}
          onAgregarPaciente={onAgregarPaciente}
          onVerCalendario={onVerCalendario}
          onToggleSidebar={onToggleSidebar}
          onTurnoCreado={(cita) => { if (cita.date === fecha) setRefreshSignal((n) => n + 1); }}
        />
      </div>
    </div>
  );
}

export default PanelInicio;
